<template>
  <div>
    <div class="form-group">
      <label>要介護認定</label>
      <br />
      <select class="select-control" v-model="needsNursingCareSelected" @change="changeCareCertification">
        <option v-for="needsNursingCareOption in needsNursingCareOptions" v-bind:value="needsNursingCareOption.value" :key="needsNursingCareOption.text">
          {{ needsNursingCareOption.text }}
        </option>
      </select>
    </div>

    <div class="form-group">
      <label>介護保険利用状況</label>
      <br />
      <select class="select-control" v-model="longTermCareInsuranceSelected" @change="changeCareInsurance">
        <option v-for="longTermCareInsuranceOption in longTermCareInsuranceOptions" v-bind:value="longTermCareInsuranceOption.value" :key="longTermCareInsuranceOption.text">
          {{ longTermCareInsuranceOption.text }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: "NursingPage",
  data() {
    return {
      needsNursingCareSelected: 0,
      longTermCareInsuranceSelected: 0,
      needsNursingCareOptions: [
        { text: "選択してください", value: 0 },
        { text: "非該当", value: 1 },
        { text: "要支援１", value: 2 },
        { text: "要支援２", value: 3 },
        { text: "要介護１", value: 4 },
        { text: "要介護２", value: 5 },
        { text: "要介護３", value: 6 },
        { text: "要介護４", value: 7 },
        { text: "要介護５", value: 8 },
      ],
      longTermCareInsuranceOptions: [
        { text: "選択してください", value: 0 },
        { text: "非該当", value: 1 },
        { text: "１割負担", value: 2 },
        { text: "２割負担", value: 3 },
        { text: "３割負担", value: 4 },
      ],
    };
  },
  methods: {
    changeCareCertification() {
      this.$emit("handle-change-care-certification",this.needsNursingCareSelected)
    },
    changeCareInsurance() {
      this.$emit("handle-change-care-insurance", this.longTermCareInsuranceSelected)
    }
  }
};
</script>

<style scoped>
select option:first-child {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/templates/NursingPage.vue